import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { INavigator } from './navigator';
import { NavigationEnd, Router } from '@angular/router';

// For some reason, providing this service in NavigatorModule is creating a different instance so I am providing in root for now.
@Injectable({ providedIn: 'root' })
export class NavigatorService {
  private _paths$ = new BehaviorSubject<INavigator[]>([]);

  public get paths$(): Observable<INavigator[]> {
    return this._paths$.asObservable();
  }

  constructor(private _router: Router) {
    this._router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        this.clearNavigator();
      }
    });
  }

  public setNavigator(paths: INavigator[]): void {
    this._paths$.next(paths);
  }

  public clearNavigator(): void {
    this._paths$.next([]);
  }

  public setHomePath(): void {
    const paths: INavigator[] = [
      {
        path: '/',
        name: 'Home',
      },
    ];
    this._paths$.next(paths);
  }
}
